import { render, staticRenderFns } from "./DefaultLP.vue?vue&type=template&id=3ee7d0e4"
import script from "./DefaultLP.vue?vue&type=script&lang=js"
export * from "./DefaultLP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports